import React, { useState, useEffect } from "react";
import SlideOver from "../SlideOver";
import NavBarRight from "./NavBarRight";
import SlideOverContent from "./SlideOverContent";
import CNLogo from "../CNLogo";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleNotch, faSearch } from "@fortawesome/free-solid-svg-icons";
import {
  getSearchResults,
  getSearchResultsForDropdown,
} from "../../redux/actions/search";
import { getAllCourses } from "../../redux/actions/courses";
import { useDispatch, useSelector } from "react-redux";
import CoursesDropdownV2 from "./CoursesDropdownV2";
import { faBars } from "@fortawesome/free-solid-svg-icons";
import { useLocation, useNavigate } from "react-router-dom";
import { useDebounce } from "../../hooks/useDebounce";
import SearchResultsDropdown from "./SearchResultsDropdown";
import AdBanner from "./AdBanner";
import SevenDayTrial from "./7dayTrail/SevenDayTrial";
import { getEpsFormData } from "../../redux/actions/jobEligibilityScore";
import { setEpsData } from "../../redux/actions/userActivity";
import { validPaths } from "../../common/constants";

const settings = {
  dots: false,
  slidesToShow: 9,
  rows: 1,
  speed: 300,
  infinite: false,
  cssEase: "linear",
  adaptiveHeight: true,
};

const getCategoryIcon = (course) => {
  const text = (
    (course?.course_slug || "") +
    " " +
    (course?.["course-name"] || "")
  ).toLowerCase();
  if (text.includes("prog") || text.includes("code") || text.includes("dev")) {
    return (
      <svg
        className="h-[17px] w-[17px] text-[#06769E]"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <polyline points="16 18 22 12 16 6" />
        <polyline points="8 6 2 12 8 18" />
      </svg>
    );
  }
  if (text.includes("ai") || text.includes("artif") || text.includes("intel")) {
    return (
      <svg
        className="h-[17px] w-[17px] text-[#06769E]"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M12 2a4 4 0 0 0-4 4v1H6a2 2 0 0 0-2 2v2a2 2 0 0 0 2 2h2v1a4 4 0 0 0 8 0v-1h2a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-2V6a4 4 0 0 0-4-4z" />
      </svg>
    );
  }
  if (text.includes("market")) {
    return (
      <svg
        className="h-[17px] w-[17px] text-[#06769E]"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="m3 11 18-5v12L3 14v-3z" />
        <path d="M11.6 16.8a3 3 0 1 1-5.8-1.6" />
      </svg>
    );
  }
  if (text.includes("design") || text.includes("art")) {
    return (
      <svg
        className="h-[17px] w-[17px] text-[#06769E]"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <circle cx="13.5" cy="6.5" r=".5" fill="currentColor" />
        <circle cx="17.5" cy="10.5" r=".5" fill="currentColor" />
        <circle cx="8.5" cy="7.5" r=".5" fill="currentColor" />
        <circle cx="6.5" cy="12.5" r=".5" fill="currentColor" />
        <path d="M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10c.926 0 1.648-.746 1.648-1.688 0-.437-.18-.835-.437-1.125-.29-.289-.438-.652-.438-1.125a1.64 1.64 0 0 1 1.668-1.668h1.996c3.051 0 5.555-2.503 5.555-5.554C21.965 6.012 17.461 2 12 2z" />
      </svg>
    );
  }
  if (text.includes("data") || text.includes("analy")) {
    return (
      <svg
        className="h-[17px] w-[17px] text-[#06769E]"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M18 20V10" />
        <path d="M12 20V4" />
        <path d="M6 20v-6" />
      </svg>
    );
  }
  if (text.includes("busin") || text.includes("manag")) {
    return (
      <svg
        className="h-[17px] w-[17px] text-[#06769E]"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <rect width="20" height="14" x="2" y="7" rx="2" />
        <path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16" />
      </svg>
    );
  }
  if (text.includes("ui") || text.includes("ux")) {
    return (
      <svg
        className="h-[17px] w-[17px] text-[#06769E]"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <rect width="7" height="9" x="3" y="3" rx="1" />
        <rect width="7" height="5" x="14" y="3" rx="1" />
        <rect width="7" height="9" x="14" y="12" rx="1" />
        <rect width="7" height="5" x="3" y="16" rx="1" />
      </svg>
    );
  }
  return (
    <svg
      className="h-[17px] w-[17px] text-[#06769E]"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H20v20H6.5a2.5 2.5 0 0 1-2.5-2.5Z" />
      <path d="M6 6h10" />
      <path d="M6 10h10" />
    </svg>
  );
};

const Navbar = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isSlideOver, setSlideOver] = useState(false);
  const [userLoggedIn, setUserLoggedIn] = useState(false);
  const [searchString, setSearchString] = useState("");
  const [searchLoader, setSearchLoader] = useState(false);
  const [dropdownResults, setDropdownResult] = useState("");
  const [inputFocus, setInputFocus] = useState(false);
  const [allCourses, setAllCourses] = useState([]);
  const [isMegaMenu, setIsMegaMenu] = useState(true);
  const [searchBtn, setSearchBtn] = useState(false);
  const [noSearch, setNoSearch] = useState("");

  const isUserTokenPresent = useSelector((store) =>
    store?.authentication?.user_token ? true : false,
  );
  const email = useSelector((store) => store?.profileDetails?.email);
  const userId = useSelector((store) => store?.profileDetails?.id);
  const subscription_type = useSelector(
    (store) => store?.userSubscription?.subscription_type,
  );
  const countDownDate = useSelector(
    (store) => store?.userSubscription?.current_subscription_expires_at,
  );
  const all_courses = useSelector((store) => store?.courses?.allCourses);
  const isDarkOverlay = useSelector((store) => store?.appTheme?.blackOverlay);
  const role_type = useSelector((store) => store?.userSubscription?.role_type);
  let location = useLocation();

  const width = window.innerWidth;

  const profile_image = useSelector(
    (store) => store?.profileDetails?.profile_image,
  );

  const handleSearch = (e) => {
    if (e.key === "Enter" && searchString !== "") {
      setSearchLoader(true);
      dispatch(
        getSearchResults(searchString, userId, (res) => {
          if (res) setSearchLoader(false);
          navigate("/search", { replace: true });
          console.log("invoke1");
          setNoSearch(searchString);
          setSearchString("");
          setDropdownResult(null);
          setSearchBtn(false);
        }),
      );
    }
  };

  const handleSearchClick = (e) => {
    if (!searchString) return;
    setSearchLoader(true);

    dispatch(
      getSearchResults(searchString, userId, (res) => {
        if (res) setSearchLoader(false);
        navigate("/search", { replace: true });
        console.log("invoke2");
        setNoSearch(searchString);
        setSearchString("");
        setSearchBtn(false);
      }),
    );
  };

  useEffect(() => {
    if (!all_courses || all_courses.length === 0) {
      dispatch(getAllCourses());
    } else {
      setAllCourses(all_courses);
    }
  }, [all_courses, dispatch]);

  useEffect(() => {
    setSearchBtn(false);
    setSearchString("");
    setDropdownResult(null);
  }, [location.pathname]);

  useEffect(() => {
    if (location?.pathname?.includes("-courses")) setIsMegaMenu(false);
    else setIsMegaMenu(true);

    //dispatch(getEpsFormData(userId, successObj => dispatch(setEpsData(successObj))));
  }, [location]);

  useEffect(() => {
    setUserLoggedIn(isUserTokenPresent);
  }, [isUserTokenPresent]);

  // const handleInputChange = useDebounce((e) => {
  //     if (e.target.value === "") {
  //         setDropdownResult(null)
  //         return;
  //     }
  //     setSearchString(e.target.value);
  //     dispatch(getSearchResultsForDropdown(e.target.value, (res) => {
  //         setDropdownResult(res);
  //     }));
  // }, 300);

  const debouncedSearchValue = useDebounce(searchString, 500);

  useEffect(() => {
    if (debouncedSearchValue) {
      dispatch(
        getSearchResultsForDropdown(debouncedSearchValue, (res) => {
          setDropdownResult(res);
        }),
      );
    } else {
      setDropdownResult(null);
    }
  }, [debouncedSearchValue]);

  return (
    <>
      {location.pathname !== "/player-gateway" &&
        location.pathname !== "/player-unlock" &&
        !location.pathname.startsWith("/personalise") &&
        location.pathname !== "/pricing" &&
        location.pathname !== "/verification" &&
        !location.pathname.includes("/verify/certificate") &&
        location.pathname !== "/knowledge-graph" &&
        location.pathname !== "/onboarding" &&
        location.pathname !== "/onboarding/loader" &&
        location.pathname !== "/set-password" &&
        location.pathname !== "/" &&
        location.pathname !== "/hackathon" &&
        location.pathname !== "/knowledge-graph" &&
        location.pathname !== "/onboarding" &&
        location.pathname !== "/onboarding/loader" &&
        !validPaths.includes(location.pathname) &&
        location.pathname !== "/onboarding/analysis" &&
        location.pathname !== "/halloffame/" &&
        !location.pathname.includes("/halloffame/") &&
        location.pathname !== "/recruiter" &&
        location.pathname !== "/recruiter/" &&
        location.pathname !== "/recruiter/results" &&
        location.pathname !== "/recruiter/profile" &&
        location.pathname !== "/recruiter/signup" &&
        location.pathname !== "/leaderboard" && (
          <div className="sticky top-0 z-50 h-fit border-b border-[#DDE4ED] bg-white shadow-[0_1px_4px_0_rgba(14,27,46,0.08)]">
            {location.pathname !== "/pricing" && <AdBanner />}
            <div>
              <SlideOver
                open={isSlideOver}
                setOpen={setSlideOver}
                title={email}
                scroll={true}
              >
                <SlideOverContent
                  isUserLoggedIn={userLoggedIn}
                  open={isSlideOver}
                  setOpen={setSlideOver}
                />
              </SlideOver>

              <div className="flex h-[56px] items-center justify-between gap-3 px-4 md:h-[76px] md:gap-6 md:px-8 lg:gap-[40px] lg:px-[80px]">
                {/* Brand Lockup */}
                <div className="flex shrink-0 items-center gap-[9px] md:gap-4">
                  {/* <FontAwesomeIcon onClick={(e) => setSlideOver(true)} icon={faBars} size="lg" className="mr-1 self-center block md:hidden text-[#0E1B2E] cursor-pointer" /> */}
                  <a className="self-center" href="/">
                    <div className="flex items-center gap-2 md:gap-2.5">
                      <div className="flex h-[22px] w-[22px] shrink-0 items-center justify-center overflow-hidden rounded-[6px] shadow-sm md:h-[34px] md:w-[34px] md:rounded-[9px]">
                        <img
                          src="https://img.learntube.ai/public-assets/Learntube/Mark%20Plate.webp"
                          loading="eager"
                          alt="LearnTube"
                          className="h-full w-full object-contain"
                        />
                      </div>
                      <p
                        className={`${"text-[13px] md:text-[17px]"} whitespace-nowrap font-bold tracking-tight text-[#0E1B2E]`}
                      >
                        LearnTube.ai
                      </p>
                    </div>
                  </a>

                  {width > 360 && (
                    <div className="h-[22px] w-[1px] shrink-0 bg-[#DDE4ED] md:h-[30px]" />
                  )}

                  {width > 360 && (
                    <div className="flex shrink-0 flex-col gap-[1px] md:gap-[2px]">
                      <span className="whitespace-nowrap text-[7px] font-medium leading-none text-[#78899F] md:text-[11px]">
                        backed by
                      </span>
                      <div className="flex items-center gap-1 md:gap-1.5">
                        <svg
                          className="h-[10px] w-[31px] md:h-[18px] md:w-[57px]"
                          viewBox="0 0 41 13"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M1.04297 5.03024c0-2.77206 2.3228-5.01838 5.09488-5.01838 1.52942 0 2.61913 0.60221 3.44119 1.38603l-0.975 0.96544c-0.58309-0.55441-1.37648-0.98456-2.46619-0.98456-2.01692 0-3.59414 1.625-3.59414 3.64191 0 2.01691 1.57722 3.64191 3.59414 3.64191 1.30956 0 2.05516-0.52573 2.5331-1.00367 0.39191-0.39192 0.65-0.95589 0.74559-1.72059h-3.27869v-1.36691h4.61695c0.0478 0.24852 0.0765 0.53529 0.0765 0.86029 0 1.03235-0.2773 2.30368-1.18535 3.20221-0.88897 0.91764-2.01692 1.40518-3.5081 1.40518-2.77208 0-5.09488-2.24636-5.09488-5.00886z"
                            fill="#4285F4"
                          />
                          <path
                            d="M14.553 3.58511c-1.7876 0-3.2405 1.35735-3.2405 3.23088 0 1.86397 1.4529 3.23091 3.2405 3.23091 1.7875 0 3.2404-1.36694 3.2404-3.23091 0-1.87353-1.4529-3.23088-3.2404-3.23088zm0 5.18088c-0.975 0-1.8258-0.80294-1.8258-1.95956 0-1.16617 0.8412-1.95955 1.8258-1.95955 0.975 0 1.8257 0.79338 1.8257 1.95955 0 1.15662-0.8507 1.95956-1.8257 1.95956z"
                            fill="#EA4335"
                          />
                          <path
                            d="M21.6272 3.58511c-1.7875 0-3.2405 1.35735-3.2405 3.23088 0 1.86397 1.453 3.23091 3.2405 3.23091 1.7875 0 3.2404-1.36694 3.2404-3.23091 0-1.87353-1.4529-3.23088-3.2404-3.23088zm0 5.18088c-0.975 0-1.8258-0.80294-1.8258-1.95956 0-1.16617 0.8412-1.95955 1.8258-1.95955 0.9845 0 1.8257 0.79338 1.8257 1.95955 0 1.15662-0.8507 1.95956-1.8257 1.95956z"
                            fill="#FBBC05"
                          />
                          <path
                            d="M30.3034 3.77449v0.52574h-0.0478c-0.3155-0.38235-0.9272-0.72647-1.7015-0.72647-1.6154 0-3.0971 1.41471-3.0971 3.24044 0 1.80662 1.4817 3.2213 3.0971 3.2213 0.7743 0 1.386-0.34409 1.7015-0.73601h0.0478v0.46839c0 1.23312-0.6596 1.89262-1.7206 1.89262-0.8699 0-1.4052-0.6213-1.625-1.147l-1.2331 0.5161c0.3537 0.8603 1.3 1.9118 2.8676 1.9118 1.6633 0 3.0684-0.975 3.0684-3.3647v-5.80221h-1.3573zm-1.625 4.98971c-0.975 0-1.7971-0.82206-1.7971-1.95 0-1.1375 0.8221-1.96912 1.7971-1.96912 0.9654 0 1.7206 0.83162 1.7206 1.96912 0.0095 1.1375-0.7552 1.95-1.7206 1.95z"
                            fill="#4285F4"
                          />
                          <path
                            d="M34.0475 9.84766h-1.4147v-9.49192h1.4147v9.49192z"
                            fill="#34A853"
                          />
                          <path
                            d="M37.9405 8.76599c-0.7265 0-1.2331-0.33456-1.5677-0.975l4.3207-1.7875-0.1434-0.36323c-0.2677-0.72647-1.0897-2.05515-2.7625-2.05515-1.6633 0-3.0493 1.30956-3.0493 3.23088 0 1.80662 1.3669 3.23091 3.2022 3.23091 1.4816 0 2.3324-0.90811 2.6956-1.43385l-1.0993-0.73603c-0.3728 0.5353-0.8698 0.88897-1.5963 0.88897zm-0.1051-3.93823c0.5639 0 1.0419 0.2772 1.1948 0.68823l-2.8868 1.19486c-0.0382-1.24265 0.9655-1.88309 1.692-1.88309z"
                            fill="#EA4335"
                          />
                        </svg>
                        <svg
                          className="h-[10px] w-[48px] md:h-[18px] md:w-[90px]"
                          viewBox="0 0 65 13"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M4.14813 0.94141c0.4143 0 0.75403 0.07043 1.01919 0.21129l-0.31073 1.00676c-0.19887-0.09943-0.42259-0.14915-0.67117-0.14915-0.28173 0-0.51374 0.09943-0.69604 0.2983-0.17401 0.19058-0.26101 0.44745-0.26101 0.77061v0.77061h1.59093v1.04404h-1.59093v5.04624h-1.14348v-5.04624h-1.14348v-1.04404h1.14348v-0.88247c0-0.60489 0.19058-1.09377 0.57174-1.46665 0.38945-0.37287 0.88661-0.5593 1.4915-0.5593z"
                            fill="#0E1B2E"
                          />
                          <path
                            d="M5.19141 6.89635c0-0.93633 0.29415-1.71108 0.88246-2.32425 0.5966-0.61317 1.3465-0.91976 2.24968-0.91976 0.90319 0 1.64894 0.30659 2.23725 0.91976 0.5966 0.61317 0.8949 1.38792 0.8949 2.32425 0 0.94462-0.2983 1.71937-0.8949 2.32425-0.58831 0.61318-1.33406 0.9198-2.23725 0.9198-0.90318 0-1.65308-0.30662-2.24968-0.9198-0.58831-0.61317-0.88246-1.38792-0.88246-2.32425zm1.14348 0c0 0.65461 0.19058 1.18491 0.57174 1.59093 0.38116 0.40602 0.85347 0.60903 1.41692 0.60903 0.56346 0 1.03576-0.20301 1.41693-0.60903 0.38112-0.40602 0.57172-0.93632 0.57172-1.59093 0-0.64631-0.1906-1.17248-0.57172-1.5785-0.38945-0.4143-0.86176-0.62146-1.41693-0.62146-0.55517 0-1.02748 0.20716-1.41692 0.62146-0.38116 0.40602-0.57174 0.93219-0.57174 1.5785z"
                            fill="#0E1B2E"
                          />
                          <path
                            d="M13.5263 9.94007h-1.1435v-6.09028h1.0938v0.99433h0.0497c0.116-0.32316 0.3522-0.5966 0.7085-0.82032 0.3645-0.23201 0.7208-0.34802 1.0689-0.34802 0.3314 0 0.6131 0.04972 0.8451 0.14915l-0.348 1.1062c-0.1408-0.05801-0.3646-0.08701-0.6711-0.08701-0.4309 0-0.8079 0.17401-1.1311 0.52202-0.3149 0.34802-0.4723 0.75404-0.4723 1.21806v3.35587z"
                            fill="#0E1B2E"
                          />
                          <path
                            d="M24.9692 7.56792c0 0.77889-0.2859 1.40449-0.8576 1.8768-0.58 0.46402-1.2844 0.69608-2.113 0.69608-0.7374 0-1.3879-0.21548-1.9514-0.64636-0.5634-0.43088-0.9529-1.01919-1.1683-1.76494l1.0938-0.44745c0.0745 0.26516 0.1781 0.50545 0.3107 0.72089 0.1326 0.21544 0.2859 0.40188 0.4599 0.55931 0.1823 0.14915 0.3811 0.2693 0.5966 0.36045 0.2154 0.08286 0.4433 0.12429 0.6836 0.12429 0.522 0 0.9487-0.13258 1.2802-0.39773 0.3314-0.27344 0.4972-0.63389 0.4972-1.08134 0-0.37287-0.1368-0.69189-0.4102-0.95704-0.2569-0.25687-0.7375-0.50545-1.4418-0.74575-0.7126-0.25687-1.1559-0.43088-1.3299-0.52203-0.9446-0.48059-1.4169-1.18905-1.4169-2.12538 0-0.6546 0.261-1.21391 0.783-1.67794 0.5303-0.46402 1.1808-0.69603 1.9514-0.69603 0.6794 0 1.2678 0.17401 1.7649 0.52203 0.4972 0.33973 0.8286 0.76646 0.9944 1.2802l-1.069 0.44745c-0.0994-0.33145-0.2983-0.60489-0.5966-0.82033-0.29-0.22372-0.6463-0.33558-1.0689-0.33558-0.4474 0-0.8244 0.12429-1.131 0.37287-0.3066 0.23201-0.4599 0.53445-0.4599 0.90733 0 0.30658 0.1202 0.57174 0.3604 0.79546 0.2652 0.22373 0.8411 0.48888 1.7277 0.79547 0.9032 0.30659 1.5454 0.6836 1.9265 1.13105 0.3895 0.43917 0.5842 0.98191 0.5842 1.62822z"
                            fill="#0E1B2E"
                          />
                          <path
                            d="M28.2426 10.0463c-0.4972 0-0.9115-0.15332-1.2429-0.4599-0.3232-0.30659-0.4889-0.73332-0.4972-1.28021v-3.40558h-1.0689v-1.04405h1.0689v-1.86437h1.1435v1.86437h1.4915v1.04405h-1.4915v3.03271c0 0.40602 0.0787 0.6836 0.2361 0.83275 0.1575 0.14087 0.3356 0.2113 0.5345 0.2113 0.0911 0 0.1781-0.00829 0.261-0.02486 0.0911-0.02486 0.174-0.05386 0.2486-0.087l0.3604 1.01919c-0.2983 0.10772-0.6463 0.1616-1.044 0.1616z"
                            fill="#0E1B2E"
                          />
                          <path
                            d="M30.9347 8.07712c0 0.2983 0.1243 0.54688 0.3729 0.74575 0.2568 0.19887 0.5551 0.2983 0.8949 0.2983 0.4805 0 0.9073-0.17815 1.2802-0.53445 0.3811-0.35631 0.5717-0.77475 0.5717-1.25535-0.3563-0.28173-0.8535-0.42259-1.4915-0.42259-0.464 0-0.8535 0.11186-1.1683 0.33559-0.3066 0.22372-0.4599 0.50131-0.4599 0.83275zm1.479-4.42478c0.8452 0 1.5123 0.22787 2.0011 0.68361 0.4889 0.44745 0.7334 1.06476 0.7334 1.85194v3.7536h-1.0938v-0.84518h-0.0497c-0.4723 0.69603-1.1021 1.04409-1.8893 1.04409-0.6711 0-1.2346-0.19891-1.6903-0.59664-0.4475-0.39773-0.6712-0.8949-0.6712-1.4915 0-0.62974 0.2362-1.13105 0.7085-1.50392 0.4806-0.37288 1.1186-0.55932 1.9141-0.55932 0.6794 0 1.2387 0.1243 1.6779 0.37288v-0.26101c0-0.39774-0.1574-0.73332-0.4723-1.00676-0.3149-0.28173-0.6836-0.4226-1.1062-0.4226-0.638 0-1.1435 0.2693-1.5164 0.8079l-1.0067-0.63389c0.5551-0.79546 1.3755-1.1932 2.4609-1.1932z"
                            fill="#0E1B2E"
                          />
                          <path
                            d="M43.5757 10.0463c-0.4971 0-0.9114-0.15332-1.2429-0.4599-0.3231-0.30659-0.4889-0.73332-0.4971-1.28021v-3.40558h-1.0689v-1.04405h1.0689v-1.86437h1.1434v1.86437h1.4915v1.04405h-1.4915v3.03271c0 0.40602 0.0788 0.6836 0.2362 0.83275 0.1574 0.14087 0.3356 0.2113 0.5344 0.2113 0.0912 0 0.1782-0.00829 0.2611-0.02486 0.0911-0.02486 0.174-0.05386 0.2485-0.087l0.3605 1.01919c-0.2983 0.10772-0.6463 0.1616-1.0441 0.1616zm-7.1343-6.18974h1.0938v0.99433h0.0497c0.3397-0.77889 1.0399-1.16834 2.1005-1.16834l0.2362 0.02486v1.1932l-0.5096-0.04972c-0.5303 0-0.9695 0.16572-1.3175 0.49717-0.3397 0.32315-0.5096 0.73746-0.5096 1.24291v3.35587h-1.1435v-6.09028z"
                            fill="#0E1B2E"
                          />
                          <path
                            d="M50.9138 9.94185h-1.0938v-0.84519h-0.0497c-0.174 0.2983-0.4433 0.54689-0.8079 0.74575-0.3563 0.19889-0.7292 0.29829-1.1186 0.29829-0.7458 0-1.3217-0.21128-1.7277-0.63387-0.3977-0.43088-0.5966-1.03991-0.5966-1.82709v-3.82818h1.1435v3.75361c0.0249 0.99433 0.5262 1.49149 1.5039 1.49149 0.4558 0 0.8369-0.18229 1.1435-0.54688 0.3066-0.37287 0.4599-0.81618 0.4599-1.32992v-3.3683h1.1435v6.09029z"
                            fill="#0E1B2E"
                          />
                          <path
                            d="M55.3022 9.09631c0.5469 0 1.0068-0.20715 1.3797-0.62146 0.3729-0.40602 0.5593-0.93218 0.5593-1.5785 0-0.63803-0.1864-1.16419-0.5593-1.5785-0.3729-0.4143-0.8328-0.62146-1.3797-0.62146-0.5551 0-1.0191 0.20716-1.392 0.62146-0.3646 0.41431-0.5469 0.94047-0.5469 1.5785 0 0.64632 0.1823 1.17663 0.5469 1.59093 0.3729 0.40602 0.8369 0.60903 1.392 0.60903zm0.1865 1.04409c-0.4475 0-0.8576-0.0953-1.2305-0.28591-0.3646-0.19058-0.6463-0.44331-0.8452-0.75818h-0.0497l0.0497 0.84518v2.68471h-1.1435v-8.77499h1.0938v0.84518h0.0497c0.1989-0.31487 0.4806-0.5676 0.8452-0.75818 0.3729-0.19058 0.783-0.28587 1.2305-0.28587 0.8037 0 1.4832 0.31488 2.0384 0.94462 0.5717 0.63803 0.8576 1.40449 0.8576 2.29939 0 0.90319-0.2859 1.66965-0.8576 2.29939-0.5552 0.62975-1.2347 0.94466-2.0384 0.94466z"
                            fill="#0E1B2E"
                          />
                          <path
                            d="M64.0235 8.25113c0 0.53031-0.232 0.97776-0.696 1.34235-0.464 0.36459-1.0482 0.54692-1.7525 0.54692-0.6132 0-1.1518-0.15747-1.6158-0.47235-0.464-0.32315-0.7955-0.74575-0.9944-1.26777l1.0192-0.43502c0.1492 0.36459 0.3646 0.65046 0.6464 0.85761 0.29 0.19887 0.6048 0.2983 0.9446 0.2983 0.3646 0 0.667-0.07872 0.9073-0.23615 0.2486-0.15744 0.3729-0.34388 0.3729-0.55931 0-0.38945-0.2983-0.67532-0.8949-0.85762l-1.0441-0.26101c-1.1849-0.2983-1.7773-0.87004-1.7773-1.71522 0-0.55517 0.2237-0.99848 0.6711-1.32992 0.4558-0.33973 1.0358-0.5096 1.7401-0.5096 0.5386 0 1.0233 0.12844 1.4542 0.38531 0.4392 0.25687 0.7458 0.60074 0.9198 1.03162l-1.0192 0.42259c-0.116-0.25687-0.3066-0.45574-0.5718-0.5966-0.2568-0.14915-0.5468-0.22373-0.87-0.22373-0.2983 0-0.5676 0.07458-0.8079 0.22373-0.232 0.14915-0.348 0.33144-0.348 0.54688 0 0.34802 0.3273 0.5966 0.9819 0.74575l0.9198 0.23615c1.2097 0.2983 1.8146 0.90733 1.8146 1.82709z"
                            fill="#0E1B2E"
                          />
                        </svg>
                      </div>
                    </div>
                  )}

                  {/* {subscription_type === "trial" && <SevenDayTrial countDownDate={countDownDate}/>} */}
                </div>

                {/* Unified Search Bar on Desktop (Pencil design) */}
                <div className="relative z-40 hidden flex-1 items-center rounded-[8px] border border-[#DDE4ED] bg-[#F4F7FA] transition-colors focus-within:border-[#0E1B2E] md:flex">
                  {/* Category Select (CoursesDropdownV2) */}
                  <CoursesDropdownV2 />

                  {/* Search Input Field */}
                  <div className="relative flex flex-1 items-center gap-2.5 px-4 py-[11px]">
                    {searchLoader ? (
                      <FontAwesomeIcon
                        className="shrink-0 animate-spin text-teal-600"
                        size="sm"
                        icon={faCircleNotch}
                      />
                    ) : (
                      <svg
                        className="h-4 w-4 shrink-0 text-[#4A5A70]"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <circle cx="11" cy="11" r="8" />
                        <path d="m21 21-4.3-4.3" />
                      </svg>
                    )}
                    <input
                      type="text"
                      className="w-full border-none bg-transparent p-0 text-[13px] font-medium text-[#0E1B2E] placeholder-[#4A5A70] outline-none focus:ring-0"
                      value={searchString}
                      onKeyPress={handleSearch}
                      onChange={(e) => {
                        setSearchString(e.target.value);
                        setNoSearch(e.target.value);
                      }}
                      onFocus={(e) => setInputFocus(true)}
                      onBlur={(e) => {
                        setTimeout(() => {
                          setInputFocus(false);
                        }, 650);
                      }}
                      placeholder="Search skills, courses or jobs…"
                    ></input>
                    {dropdownResults && inputFocus && searchString?.length > 0 && (
                      <div className="absolute top-2 left-0 right-0 z-50 mt-0">
                        <SearchResultsDropdown
                          results={dropdownResults}
                          setSearchString={setSearchString}
                          searchString={searchString}
                          isEmpty={
                            dropdownResults?.results !== "empty" ? false : true
                          }
                          noSearch={noSearch}
                        />
                      </div>
                    )}
                    {/* {
                                    !searchLoader ?
                                        <FontAwesomeIcon onClick={handleSearchClick} icon={faSearch} className="text-[#4A5A70] hover:text-[#0E1B2E] cursor-pointer shrink-0" size="sm" />
                                        :
                                        <FontAwesomeIcon className='animate-spin text-teal-600 shrink-0' size='sm' icon={faCircleNotch} />
                                } */}
                  </div>
                </div>

                {/* Right Section */}
                <NavBarRight
                  userLoggedIn={userLoggedIn}
                  setSlideOver={setSlideOver}
                  setSearchBtn={setSearchBtn}
                  searchBtn={searchBtn}
                />
              </div>

              {/* Mobile Search Active Full-Screen (Pencil Node ID: Dq7lH) */}
              {searchBtn && (
                <div className="fixed inset-0 z-50 flex flex-col overflow-y-auto bg-[#F4F7FA] md:hidden">
                  {/* Search Bar */}
                  <div className="sticky top-0 z-10 flex w-full shrink-0 flex-row items-center justify-start gap-3 border-b border-[#DDE4ED] bg-white p-[12px_16px]">
                    <button
                      type="button"
                      onClick={() => {
                        setSearchBtn(false);
                        setSearchString("");
                        setDropdownResult(null);
                      }}
                      className="-ml-1 cursor-pointer p-1 text-[#0E1B2E]"
                      aria-label="Back"
                    >
                      <svg
                        className="h-[22px] w-[22px]"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <path d="m12 19-7-7 7-7" />
                        <path d="M19 12H5" />
                      </svg>
                    </button>

                    <div className="flex h-fit flex-1 flex-row items-center justify-start gap-[10px] rounded-full border border-[#06769E] bg-[#EDF1F7] p-[10px_14px]">
                      <svg
                        className="h-[17px] w-[17px] shrink-0 text-[#06769E]"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <circle cx="11" cy="11" r="8" />
                        <path d="m21 21-4.3-4.3" />
                      </svg>
                      <input
                        type="text"
                        className="w-full border-none bg-transparent p-0 text-[14px] font-medium text-[#0E1B2E] placeholder-[#78899F] outline-none focus:ring-0"
                        value={searchString}
                        onKeyPress={handleSearch}
                        onChange={(e) => {
                          setSearchString(e.target.value);
                          setNoSearch(e.target.value);
                        }}
                        placeholder="Search skills, courses or jobs…"
                        autoFocus
                      />
                      {searchLoader ? (
                        <FontAwesomeIcon
                          className="shrink-0 animate-spin text-[#06769E]"
                          size="sm"
                          icon={faCircleNotch}
                        />
                      ) : searchString ? (
                        <button
                          type="button"
                          onClick={() => {
                            setSearchString("");
                            setNoSearch("");
                            setDropdownResult(null);
                          }}
                          className="cursor-pointer p-0.5 text-[#78899F] hover:text-[#0E1B2E]"
                        >
                          <svg
                            className="h-4 w-4"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                          >
                            <line x1="18" y1="6" x2="6" y2="18"></line>
                            <line x1="6" y1="6" x2="18" y2="18"></line>
                          </svg>
                        </button>
                      ) : (
                        <div className="h-[18px] w-[2px] shrink-0 animate-pulse bg-[#06769E]"></div>
                      )}
                    </div>
                  </div>

                  {/* Content area: Search Results OR Browse Categories */}
                  {searchString.trim() !== "" ? (
                    dropdownResults ? (
                      <div className="relative z-20 w-full flex-1 bg-white">
                        <SearchResultsDropdown
                          results={dropdownResults}
                          setSearchString={(val) => {
                            setSearchString(val);
                            if (!val) setSearchBtn(false);
                          }}
                          isEmpty={
                            dropdownResults?.results !== "empty" ? false : true
                          }
                          noSearch={noSearch}
                        />
                      </div>
                    ) : (
                      <div className="flex-1 bg-white p-8 text-center text-sm font-medium text-[#78899F]">
                        Searching for "{searchString}"...
                      </div>
                    )
                  ) : (
                    <div className="flex w-full flex-col gap-[12px] p-[24px_20px_32px_20px]">
                      <div className="text-[13px] font-bold tracking-[0.4px] text-[#0E1B2E]">
                        Browse categories
                      </div>
                      <div className="flex w-full flex-col rounded-[12px] border border-[#DDE4ED] bg-white p-[6px]">
                        {(allCourses?.length ? allCourses : all_courses)?.map(
                          (course, idx) => (
                            <React.Fragment key={course.course_slug || idx}>
                              {idx > 0 && (
                                <div className="h-[1px] w-full bg-[#DDE4ED]" />
                              )}
                              <div
                                onClick={() => {
                                  setSearchBtn(false);
                                  setSearchString("");
                                  navigate(`/${course.course_slug}`, {
                                    replace: true,
                                  });
                                }}
                                className="flex w-full cursor-pointer flex-row items-center justify-between gap-[11px] rounded-[8px] p-[11px_10px] transition-colors hover:bg-slate-50"
                              >
                                <div className="flex min-w-0 items-center gap-[11px] pr-2">
                                  <div className="bg-[#06769E]/15 flex h-[32px] w-[32px] shrink-0 items-center justify-center rounded-[10px]">
                                    {course?.course_icon?.url ? (
                                      <img
                                        src={course.course_icon.url}
                                        alt=""
                                        className="h-4 w-4 object-contain"
                                      />
                                    ) : (
                                      getCategoryIcon(course)
                                    )}
                                  </div>
                                  <div className="flex min-w-0 flex-col gap-[2px] text-left">
                                    <span className="truncate text-[14px] font-bold text-[#0E1B2E]">
                                      {course["course-name"]
                                        ?.replace("Course", "")
                                        ?.trim()}
                                    </span>
                                    <span className="text-[11px] font-medium text-[#78899F]">
                                      {course.total_skills
                                        ? `${course.total_skills}+ Courses`
                                        : `${
                                            course.course_count || "40+"
                                          }+ Courses`}
                                    </span>
                                  </div>
                                </div>
                                <svg
                                  className="h-[17px] w-[17px] shrink-0 text-[#78899F]"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  stroke="currentColor"
                                  strokeWidth="2.5"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                >
                                  <path d="m9 18 6-6-6-6" />
                                </svg>
                              </div>
                            </React.Fragment>
                          ),
                        )}
                      </div>
                      <div className="text-left text-[11px] font-medium text-[#78899F]">
                        3,174+ courses across 210+ skill categories
                      </div>
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>
        )}
    </>
  );
};

export default Navbar;
